import * as surveyAPI from "../api/surveyAPI";
import {
    CREATE_SURVEY_SUCCESS,
    UPDATE_SURVEY_SUCCESS,
    DELETE_SURVEY_SUCCESS,
    FETCH_SURVEYS_SUCCESS,
    UPDATE_SURVEY_STATUS_SUCCESS,
    DUPLICATE_SURVEY_SUCCESS,
} from "../constants/surveyConstants";

const currentOrganisationId = (getState) =>
    getState().organisation?.currentOrganisation?._id;

export const createSurvey = (organisationId, surveyData) => async (dispatch, getState) => {
    try {
        const token = getState().auth.accessToken;
        const response = await surveyAPI.createSurvey(organisationId, surveyData, token);
        dispatch({ type: CREATE_SURVEY_SUCCESS, payload: response.survey });
        return { success: true, survey: response.survey };
    } catch (error) {
        console.error("Error creating survey:", error);
        return { success: false, error: error.message || "Failed to create survey" };
    }
};

export const updateSurvey = (surveyId, surveyData) => async (dispatch, getState) => {
    try {
        const token = getState().auth.accessToken;
        const orgId = currentOrganisationId(getState);
        const response = await surveyAPI.updateSurvey(surveyId, surveyData, orgId, token);
        dispatch({ type: UPDATE_SURVEY_SUCCESS, payload: response.survey });
        return { success: true, survey: response.survey };
    } catch (error) {
        console.error("Error updating survey:", error);
        return { success: false, error: error.message || "Failed to update survey" };
    }
};

export const deleteSurvey = (surveyId, organisationId) => async (dispatch, getState) => {
    try {
        const token = getState().auth.accessToken;
        await surveyAPI.deleteSurvey(surveyId, organisationId, token);
        dispatch({ type: DELETE_SURVEY_SUCCESS, payload: surveyId });
        return { success: true };
    } catch (error) {
        console.error("Error deleting survey:", error);
        return { success: false, error: error.message || "Failed to delete survey" };
    }
};

export const fetchSurveys = (organisationId) => async (dispatch, getState) => {
    try {
        const token = getState().auth.accessToken;
        const response = await surveyAPI.fetchSurveys(organisationId, token);
        dispatch({ type: FETCH_SURVEYS_SUCCESS, payload: response.surveys });
        return { success: true, surveys: response.surveys };
    } catch (error) {
        console.error("Error fetching surveys:", error);
        return { success: false, error: error.message || "Failed to fetch surveys" };
    }
};

export const duplicateSurvey = (surveyId, organisationId) => async (dispatch, getState) => {
    try {
        const token = getState().auth.accessToken;
        const response = await surveyAPI.duplicateSurvey(surveyId, organisationId, token);
        dispatch({ type: DUPLICATE_SURVEY_SUCCESS, payload: response.survey });
        return { success: true, survey: response.survey };
    } catch (error) {
        console.error("Error duplicating survey:", error);
        return { success: false, error: error.message || "Failed to duplicate survey" };
    }
};

export const updateSurveyStatus = (surveyId, status) => async (dispatch, getState) => {
    try {
        const token = getState().auth.accessToken;
        const orgId = currentOrganisationId(getState);
        const response = await surveyAPI.updateSurveyStatus(surveyId, status, orgId, token);
        dispatch({ type: UPDATE_SURVEY_STATUS_SUCCESS, payload: response.survey });
        return { success: true, survey: response.survey };
    } catch (error) {
        console.error("Error updating survey status:", error);
        return { success: false, error: error.message || "Failed to update survey status" };
    }
};
